import { Box, Typography } from '@mui/material'
import {useState} from 'react';
import { ConfigProvider, Timeline } from 'antd';
import TopicCard from './TopicCard';
import CircleIcon from '@mui/icons-material/Circle';

export default function TopicRoadmap({topicData}) {

    const items1 = []

    topicData.forEach(topic => {
        items1.push({
            color: '#6A388C',
            children: (
                <>
                    <TopicCard topic={topic}/>
                </>
            ),
            dot: <CircleIcon fontSize='large'/>
        })
    });

    return (
        <Box sx={{
            width: '95%',
            minHeight: '100%',
            maxHeight: '100%',
            overflowY: 'auto',
            marginTop: '2%',
            paddingTop: '1%',
            paddingLeft: '5%',
        }}>
            <ConfigProvider
                theme={{
                    components: {
                        Timeline: {
                            tailColor: '#B557AF',
                            tailWidth: 3,
                            dotBg: 'transparent'
                        },
                    },
                    token: {
                        lineType: 'dashed',
                    }
                }}
            >
                <Timeline mode='left' items={items1}/>

            </ConfigProvider>
        </Box>
    )
}